document.addEventListener('DOMContentLoaded', function() {
  var opener = document.getElementById('OpenDetailsDrawer');
  var btnClose = document.getElementById('CloseDetailsDrawer');
  var overlay = document.getElementById('DetailsDrawerOverlay');
  var drawer = document.getElementById('DetailsDrawer');

  function openDrawer() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    overlay.classList.add('visible');
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    overlay.classList.remove('visible');
  }

  opener.addEventListener('click', openDrawer);
  
  if (btnClose) btnClose.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('click', function(e) {
    var clickedInsideDrawer = drawer.contains(e.target);
    var clickedOnOpener = Array.from(openers).some(function(opener) {
      return opener.contains(e.target);
    });

    if ( drawer.classList.contains('open')
      && !clickedInsideDrawer
      && !clickedOnOpener
    ) {
      closeDrawer();
    }
  });
});